module.exports = __webpack_public_path__ + "media/images/team__rippergc-74f68898e0671f4e36662e6c1aa446b8.png";